(function ($) {

	/* Document Ready */
	$(document).ready(function() {
        $(".preload").fadeOut("fast");
       
	});

    // Wait for window load
//	$(window).load(function() {
//		$(".preload").fadeOut("fast");
//	});


})(jQuery);